import { render, staticRenderFns } from "./OpenPositions.vue?vue&type=template&id=5f63d2d2&"
import script from "./OpenPositions.vue?vue&type=script&lang=js&"
export * from "./OpenPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports